'use client';
import { jsxs as x, jsx as t } from "react/jsx-runtime";
import { ToggleGroup as Ve, ToggleGroupItem as Oe } from "@radix-ui/react-toggle-group";
import { useScreenSize as Ee, useBirthDate as Le, useDisclosure as oe, useOnClickOutside as ke, formatNumberWithZeroPrefix as se, cn as N, trimZeroPrefix as Ie, useScrollableRef as Pe } from "@tameeni/shared-logic";
import { endOfMonth as Te, eachDayOfInterval as Ae } from "date-fns";
import Re, { useState as A, useRef as ae, useMemo as M, useCallback as C, useLayoutEffect as Be, useEffect as We } from "react";
import { Drawer as Ye, DrawerTrigger as ze, DrawerPortal as Fe, DrawerContent as je } from "../drawer/drawer.js";
import { Input as Ge } from "../input/input.js";
import { Popover as le, PopoverTrigger as ce, PopoverContent as ie, PopoverArrow as Ze } from "../popover/popover.js";
import { ScrollArea as _e } from "../scroll-area/scroll-area.js";
import { Icon as qe } from "@tameeni/icons";
import { useMask as He } from "@react-input/mask";
const de = "opacity-30 cursor-not-allowed";
function Ke(r) {
  var ne;
  const {
    className: l,
    placeholderText: u,
    minAge: m,
    maxAge: S,
    locale: n = "en",
    variant: y = "g",
    hasDays: c = !1,
    disabled: R,
    value: $,
    onChange: b,
    onAfterChange: D,
    disableDays: i,
    disableMonths: o,
    disabledYears: h,
    ...B
  } = r, [ue, q] = A(!1), [me, H] = A(!1), [he, K] = A(!1), [fe, pe] = A(0), ge = ae(null), V = He({
    mask: "yyyy/mm/dd",
    replacement: { d: /\d/, m: /\d/, y: /\d/ },
    showMask: !0,
    separate: !0
  }), { isMobile: W } = Ee(), { getMonths: J, getYears: Q } = Le(), U = ae(null), {
    isOpened: ye,
    onOpen: X,
    onClose: be
  } = oe(), {
    isOpened: De,
    onOpen: Se,
    onClose: we
  } = oe();
  ke(U, be);
  const Y = ((ne = $.replace(/(m|d|y)/g, "")) == null ? void 0 : ne.split("/")) ?? [], w = c ? Y[2] : "", s = Y[1], a = Y[0], xe = s && a && +s > 0 && +a > 0, z = M(
    () => Q(y, m, S),
    [Q, S, m, y]
  ), F = M(
    () => J(y, n),
    [J, n, y]
  ), j = M(
    () => Je({
      month: s ? +s : (/* @__PURE__ */ new Date()).getMonth(),
      year: a ? +a : (/* @__PURE__ */ new Date()).getFullYear()
    }).map((e) => ({ label: String(e), value: e })),
    [s, a]
  ), [O, E] = M(() => {
    const e = j.map((d) => +d.value);
    return [Math.min(...e), Math.max(...e)];
  }, [j]), [L, k] = M(() => {
    const e = F.map((d) => +d.value);
    return [Math.min(...e), Math.max(...e)];
  }, [F]), [I, P] = M(() => {
    const e = z.map((d) => +d.value);
    return [Math.min(...e), Math.max(...e)];
  }, [z]), T = C(() => {
    q(!1), H(!1), K(!1);
  }, []), v = C(
    (e = "", d = "", f = "") => {
      T();
      const g = e === "00" ? "" : e, p = d === "00" ? "" : d, $e = c ? `${f}/${p}/${g}` : `${f}/${p}`;
      b($e), D == null || D();
    },
    [T, c, b, D]
  ), ve = C(
    (e) => {
      const d = e.target.value, [f, g, p] = d.split("/");
      if (console.log({ y: f, m: g, d: p }), !(i != null && i.includes(+p) || o != null && o.includes(+g) || h != null && h.includes(+f) || p && (!f || !g))) {
        if (p.length >= 2 && (+p < O || +p > E) && !(i != null && i.includes(+p)))
          return K(!0);
        if (g.length >= 2 && (+g < L || +g > k) && !(o != null && o.includes(+g)))
          return H(!0);
        if (f.length >= 4 && (+f < I || +f > P) && !(h != null && h.includes(+f)))
          return q(!0);
        T(), b(d);
      }
    },
    [
      T,
      i,
      o,
      h,
      E,
      k,
      P,
      O,
      L,
      I,
      b
    ]
  ), Me = C(
    (e = "") => {
      v(se(Number(e)), s, a);
    },
    [s, v, a]
  ), Ce = C(
    (e = "") => {
      v(
        w,
        se(Number(e)),
        a
      );
    },
    [w, v, a]
  ), Ne = C(
    (e = "") => {
      v(w, s, e);
    },
    [w, s, v]
  );
  Be(() => {
    function e() {
      V.current && pe(V.current.offsetWidth + 32);
    }
    return e(), W || window.addEventListener("resize", e), () => {
      window.removeEventListener("resize", e);
    };
  }, [V, W]), G(a, 4, "year-value"), G(s, 2, "month-value"), G(w, 2, "day-value");
  const ee = c ? "grid-cols-3" : "grid-cols-2", te = /* @__PURE__ */ x("div", { className: N("m-h-full p-0", l), children: [
    /* @__PURE__ */ x(
      "section",
      {
        className: N(
          "grid rounded-t-lg bg-slate-100 border-b text-t3 sm:text-t2",
          ee
        ),
        children: [
          /* @__PURE__ */ t(
            Z,
            {
              title: n === "ar" ? "السنة" : "Year",
              errorMessage: n === "ar" ? `تتراوح السنة ما بين ${I} ~ ${P}` : `year range is between ${I} ~ ${P}`,
              hasErrors: ue,
              isActive: !!a
            }
          ),
          /* @__PURE__ */ t(
            Z,
            {
              title: c ? n === "ar" ? "الشهر" : "Month" : n === "ar" ? "اختر الشهر" : "Select Month",
              errorMessage: n === "ar" ? `يتراوح الشهر ما بين ${L} ~ ${k}` : `month range is between ${L} ~ ${k}`,
              hasErrors: me,
              isActive: !!s
            }
          ),
          c && /* @__PURE__ */ t(
            Z,
            {
              title: n === "ar" ? "اليوم" : "Day",
              errorMessage: n === "ar" ? `يتراوح اليوم ما بين ${O} ~ ${E}` : `day range is between ${O} ~ ${E}`,
              hasErrors: he,
              isActive: !!w
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ x("div", { className: N("max-h-[20.75rem] grid ", ee), children: [
      /* @__PURE__ */ t(
        _,
        {
          locale: n,
          currentSelectedValue: a,
          setSelectedValue: Ne,
          dateList: z,
          disabledValues: h,
          dataType: "year"
        }
      ),
      /* @__PURE__ */ t(
        _,
        {
          locale: n,
          currentSelectedValue: s,
          setSelectedValue: Ce,
          dateList: F,
          disabledValues: o,
          dataType: "month"
        }
      ),
      c && /* @__PURE__ */ t(
        _,
        {
          locale: n,
          currentSelectedValue: w,
          setSelectedValue: Me,
          dateList: j,
          disabledValues: i,
          dataType: "day",
          disabled: !xe
        }
      )
    ] })
  ] }), re = /* @__PURE__ */ t(
    Ge,
    {
      ref: V,
      suffix: /* @__PURE__ */ t(qe, { className: "absolute end-4", name: "Calendar" }),
      type: "text",
      placeholder: u,
      disabled: R,
      className: "h-10",
      value: $,
      onChange: ve,
      ...B
    }
  );
  return /* @__PURE__ */ t("div", { className: "z-30", children: W ? /* @__PURE__ */ x(Ye, { children: [
    /* @__PURE__ */ t(ze, { asChild: !0, children: re }),
    /* @__PURE__ */ t(Fe, { children: /* @__PURE__ */ t(je, { className: "h-[23rem] border rounded rounded-t-lg shadow", children: te }) })
  ] }) : /* @__PURE__ */ x(le, { open: ye, children: [
    /* @__PURE__ */ t(
      ce,
      {
        onClick: X,
        onFocus: () => {
          Se(), X();
        },
        onBlur: we,
        ref: ge,
        asChild: !0,
        children: re
      }
    ),
    /* @__PURE__ */ t(
      ie,
      {
        ref: De ? null : U,
        side: "bottom",
        style: { width: fe },
        className: "md:max-w-full max-w-full w-full p-0 border rounded rounded-t-lg shadow",
        sideOffset: 12,
        children: te
      }
    )
  ] }) });
}
const ct = Re.memo(Ke), G = (r, l, u) => {
  We(() => {
    if ((r == null ? void 0 : r.length) === l) {
      const m = document.querySelector(
        `[data-${u}="${Ie(r)}"]`
      );
      m == null || m.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
  }, [u, l, r]);
};
function Je({ month: r, year: l }) {
  const u = new Date(l, r - 1, 1), m = new Date(
    l,
    r - 1,
    Te(u).getDate()
  );
  return Ae({
    start: u,
    end: m
  }).map((y) => y.getDate());
}
const Z = (r) => /* @__PURE__ */ t(
  "h5",
  {
    className: N(
      "text-start py-1.5 border-e ps-2 sm:ps-5 last-of-type:border-e-0",
      r.isActive && "text-blue",
      r.isDisabled && de
    ),
    children: /* @__PURE__ */ x(le, { open: r.hasErrors, children: [
      /* @__PURE__ */ t(ce, { asChild: !0, children: /* @__PURE__ */ t("span", { children: r.title }) }),
      /* @__PURE__ */ x(ie, { className: "focus-visible:outline-none", children: [
        r.errorMessage,
        /* @__PURE__ */ t(Ze, {})
      ] })
    ] })
  }
), _ = (r) => {
  const {
    locale: l,
    currentSelectedValue: u,
    setSelectedValue: m,
    dateList: S,
    disabledValues: n,
    dataType: y,
    disabled: c
  } = r, R = Pe(null);
  return /* @__PURE__ */ t(
    _e,
    {
      locale: l,
      className: "h-[20.75rem] border-e pt-2",
      dir: l === "en" ? "ltr" : "rtl",
      disabled: c,
      children: /* @__PURE__ */ t(
        Ve,
        {
          type: "single",
          value: String(u),
          className: "flex flex-col px-2",
          style: {
            direction: `${l === "en" ? "ltr" : "rtl"}`
          },
          onValueChange: m,
          disabled: c,
          children: S == null ? void 0 : S.map(({ label: $, value: b }) => {
            const D = b, i = D === +u, o = n == null ? void 0 : n.includes(+b), h = `data-${y}-value`, B = o ? {} : { [h]: D };
            return /* @__PURE__ */ t(
              Oe,
              {
                ref: i ? R : null,
                disabled: o,
                value: String(D),
                className: N(
                  "mb-1 block text-start ps-2 sm:px-4 rounded py-1 transition-colors duration-500 text-c1 sm:text-s1 font-semibold sm:font-normal",
                  i ? "bg-blue-200 font-bold sm:font-semibold shadow-inner" : "hover:bg-slate-50",
                  (c || o) && de
                ),
                ...B,
                children: $
              },
              b
            );
          })
        }
      )
    }
  );
};
export {
  ct as DateSelectList
};
